import { Box, LinearProgress, Typography } from "@mui/material";
import { Commune } from "../commune-interface";

interface TotalProgressProps {
  communes: Commune[];
}

const TotalProgress = ({ communes }: TotalProgressProps) => {
  const total = communes.length;
  const found = communes.filter(c => !!c.timeFound).length;
  const percentage = total > 0 ? (found / total) * 100 : 0;
  
  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
        <Typography variant="body2" color="text.secondary">
          Progression totale
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {`${found}/${total} (${Math.round(percentage)}%)`}
        </Typography>
      </Box>
      <LinearProgress 
        variant="determinate" 
        value={percentage} 
        sx={{ 
          height: 8,
          borderRadius: 2,
          backgroundColor: 'rgba(255,255,255,0.3)',
          '& .MuiLinearProgress-bar': {
            borderRadius: 2,
            backgroundImage: percentage === 100 
              ? 'linear-gradient(to right, #4caf50, #8bc34a)'
              : undefined
          }
        }}
      />
    </Box>
  );
};

export default TotalProgress;
